import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import stylesParams from 'Groups/stylesParams';
import { LayoutType } from 'settings/consts';

import { Box } from 'wui/Box';
import { Card } from 'wui/Card';

import { Groups } from './Groups';
import { Header } from '../Header';
import { PendingGroups } from '../../PendingGroups';
import { FeedWithTitle } from '../FeedWithTitle';

const { groupCardListTopBottomSpacing, groupCardListSideSpacing } =
  stylesParams;
export function ListLayout() {
  const styles = useStyles();
  const { isMobile } = useEnvironment();

  if (isMobile) {
    return (
      <Box
        gap="SP0"
        direction="vertical"
        data-hook="layout"
        data-type={LayoutType.list}
      >
        <Header />
        <PendingGroups />
        <Groups />
        <FeedWithTitle />
      </Box>
    );
  }

  return (
    <Box
      gap="SP6"
      direction="vertical"
      data-hook="layout"
      data-type={LayoutType.list}
    >
      <Header />

      <PendingGroups />

      <Card
        paddingTop={styles.get(groupCardListTopBottomSpacing)}
        paddingBottom={styles.get(groupCardListTopBottomSpacing)}
        paddingLeft={styles.get(groupCardListSideSpacing)}
        paddingRight={styles.get(groupCardListSideSpacing)}
      >
        <Groups />
      </Card>
      <FeedWithTitle />
    </Box>
  );
}

ListLayout.displayName = 'ListLayout';
